import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { logo } from "../../assets/exports";

interface LandingNavProps {
  isAuthenticated: boolean;
}

const LandingNav = ({ isAuthenticated }: LandingNavProps) => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <img src={logo} alt="StorePilot" className="h-10" />
            <span className="ml-2 text-xl font-bold text-primary">StorePilot</span>
          </div>
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="md:hidden text-gray-700 hover:text-primary transition"
            aria-label="Toggle menu"
          >
            {menuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
          <div className="hidden md:flex items-center gap-6">
            <a href="#features" className="text-gray-700 hover:text-primary transition">Features</a>
            <a href="#pricing" className="text-gray-700 hover:text-primary transition">Pricing</a>
            <a href="#testimonials" className="text-gray-700 hover:text-primary transition">Testimonials</a>
            {!isAuthenticated && (
              <>
                <button
                  onClick={() => navigate("/login")}
                  className="text-gray-700 hover:text-primary transition"
                >
                  Sign In
                </button>
                <button
                  onClick={() => navigate("/register")}
                  className="bg-primary text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition"
                >
                  Get Started
                </button>
              </>
            )}
          </div>
        </div>
      </div>
      {menuOpen && (
        <div className="md:hidden border-t border-gray-200 bg-white/95 backdrop-blur-md animate-slide-up">
          <div className="flex flex-col px-4 py-3 gap-3">
            <a
              href="#features"
              onClick={() => setMenuOpen(false)}
              className="text-gray-700 hover:text-primary transition py-2"
            >
              Features
            </a>
            <a
              href="#pricing"
              onClick={() => setMenuOpen(false)}
              className="text-gray-700 hover:text-primary transition py-2"
            >
              Pricing
            </a>
            <a
              href="#testimonials"
              onClick={() => setMenuOpen(false)}
              className="text-gray-700 hover:text-primary transition py-2"
            >
              Testimonials
            </a>
            {!isAuthenticated && (
              <>
                <button
                  onClick={() => { setMenuOpen(false); navigate("/login"); }}
                  className="text-gray-700 hover:text-primary transition py-2 text-left"
                >
                  Sign In
                </button>
                <button
                  onClick={() => { setMenuOpen(false); navigate("/register"); }}
                  className="bg-primary text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition text-center"
                >
                  Get Started
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </nav>
  );
};

export default LandingNav;

